// /src/molecules/specialCondition/adddeposit/ConfirmationStep.jsx

import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Alert,
  Paper,
  Divider
} from "@mui/material";

import { MaterialIcons, MaterialCommunityIcons } from "@expo/vector-icons";
import { useDispatch, useSelector } from "react-redux";
import { tenantActions } from "../../../../redux/tenant.actions";
import PaymentSummary from "./PaymentSummary";
import { TenantService } from "../../../../redux/tenant.service";
import { showErrorToast, showSuccesToast } from "../../../helpers";
import { navigate } from "../../../../../../navigation/RootNavigation";
import { ActivityIndicator } from "react-native";

const TDS_URL = "https://sandbox.tenancydepositscheme.com/log-in/";

const ConfirmationStep = ({ payload = {}, openFlow = {}, handlePrev }) => {
  const dispatch = useDispatch();

  const [expanded, setExpanded] = useState("property");
  const [loading, setLoading] = useState(false);

  const [showBankPopup, setShowBankPopup] = useState(false);
  const [danDetails, setShowDan] = useState(null);
  const depositProtectionData = useSelector(
    (state) => state.tenant?.depositProtectionData
  );

  useEffect(() => {
    if (depositProtectionData?.batch_id) {
      setShowBatchId(depositProtectionData?.batch_id)
    }
  }, [depositProtectionData?.batch_id])
  const [batchId, setShowBatchId] = useState(null);
  const handleExpand = (panel) => (_e, isExpanded) =>
    setExpanded(isExpanded ? panel : false);

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString() : "N/A";

  // Register Deposit
  const handleSubmitDeposit = () => {
    const fullPayload = {
      ...payload,
    };
    TenantService.createTdSeposit(fullPayload, openFlow?.openflow_id).then((data) => {
      console.log("createTdSeposit,", data)
      //   data ={
      //     "status": true,
      //     "data": {
      //         "batch_id": "ERR-157961",
      //         "DAN": "DAN870538",
      //         "Success": "true"
      //     }
      // }
      if (data?.status) {
        const success =
          data?.data?.success === true ||
          data?.data?.success === 'true' ||
          data?.data?.Success === true ||
          data?.data?.Success === 'true';
        console.log("success", success)
        if (!success) {
          let errorMessages = [];

          // Case 1: errors.failure is an array

          if (Array.isArray(data?.data?.errors?.failure)) {
            errorMessages = data.data.errors.failure;
          }

          // Case 2: errors is a string
          else if (typeof data?.data?.errors === 'string') {
            errorMessages = [data.data.errors];
          }

          // Case 3: errors is an object with values

          else if (typeof data?.data?.errors === 'object') {
            errorMessages = Object.values(data.data.errors).flat();
          }
          const errorMessage =
            errorMessages.length > 0
              ? errorMessages.join(', ')
              : 'Authentication Failed, Kindly check Branch ID/Member ID/Api Key!';

          showErrorToast(errorMessage);
        } else {
          setShowBatchId(data?.data?.batch_id)
          showSuccesToast('Deposit created successfully');
        }
      }
    }).catch((err) => {
      showErrorToast("Something went wrong!")
    })
  };

  const handleSaveDraft = () => {
    const fullPayload = {
      ...payload,
    };
    TenantService.createTdSepositDraft(fullPayload, openFlow?.openflow_id).then((data) => {
      console.log("createTdSepositDraft", data)
      if (data?.status) {
        navigate("DepositProtectHomeSetup", openFlow?.openflow_id)
        showSuccesToast('Deposit Saved successfully');
      } else {
        showErrorToast("Something went wrong!")
      }
    }).catch((err) => {
      showErrorToast("Something went wrong!")
    })
  };
  const handlegetTdsDepositDan = () => {
    setLoading(true)
    TenantService.getTdsDepositDan(openFlow?.openflow_id).then((data) => {
      console.log("getTdsDepositDan", data)
      setLoading(false)
      if (data?.status) {
        setShowDan(data?.data)
      } else {
        showErrorToast("Something went wrong!")
      }
    }).catch((err) => {
      setLoading(false)
      showErrorToast("Something went wrong!")
    })
  };

  return (
    <>
      {batchId ? (
        <Box p={4}>
          <Typography variant="h5" fontWeight={700} mb={2}>
            Custodial Deposit
          </Typography>

          <Alert severity="info" sx={{ mt: 3 }}>
            For a deposit to be protected, we must receive it in cleared funds within 30 days of the landlord/agent receiving it. Once we receive your payment, we will allocate it to your deposit registration and send the deposit protection certificate to you and your tenant(s), usually within 2 working days.
            <br />
            <br />
            The landlord/agent must also provide the tenant(s) and any relevant person(s) with the prescribed information, including the scheme leaflet, within 30 days of the landlord/agent receiving the deposit.
            <br />
            <br />
            Deposits protection is only a legal requirement in England and Wales where the tenancy is an Assured Periodic Tenancy (APT).
          </Alert>

          <PaymentSummary
            data={[
              {
                id: batchId,
                address: openFlow?.property?.display_address,
                amount: "£" + payload?.tenancy_deposit_amount_protect,
              },
            ]}
          />

          <Grid container mt={4}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button variant="outlined" onClick={() => { setShowBankPopup(true) }}>
                  PAY BANK TRANSFER
                </Button>

                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => { alert("Coming SOON!") }}
                >
                  PAY BY CARD
                </Button>
              </Box>
            </Box>
          </Grid>
          <Dialog
            open={showBankPopup}
            onClose={() => setShowBankPopup(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle sx={{ fontWeight: 700 }}>
              Pay By Bank Transfer
            </DialogTitle>

            <DialogContent>
              <DialogContentText sx={{ mb: 2 }}>
                Transfer the deposit amount to the account below using your DAN number.
              </DialogContentText>

              <Alert severity="info" sx={{ mb: 2 }}>
                Click "Show DAN" to reveal the DAN number.
              </Alert>

              <Typography>
                <strong>Account Name:</strong> The Dispute Service Ltd
              </Typography>
              <Typography>
                <strong>Account Number:</strong> 44647190
              </Typography>
              <Typography>
                <strong>Sort Code:</strong> 60-01-15
              </Typography>

              <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    handlegetTdsDepositDan()
                  }
                  }
                >
                  {loading ? <ActivityIndicator /> : "Show DAN"}
                </Button>

                {danDetails?.dan && (
                  <Alert severity="success" sx={{ flex: 1 }}>
                    DAN: {danDetails.dan}
                  </Alert>
                )}
              </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "space-between" }}>
              <Button variant="outlined" onClick={() => setShowBankPopup(false)}>
                Cancel
              </Button>

              <Button
                variant="contained"
                color="secondary"
                disabled={!danDetails?.dan}
                onClick={() => setShowBankPopup(false)}
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      ) : (

        <Box
          sx={{
            p: 0.5,
            width: "100%",
            maxWidth: "100%",
            overflowX: "hidden",
            boxSizing: "border-box",
          }}
        >
          <Typography variant="h5" fontWeight={700} mb={1}>
            Please review your deposit details
          </Typography>

          <Typography variant="body1" color="text.secondary" mb={1}>
            Below is a summary of your deposit registration. You can go back and
            edit your steps if needed.
          </Typography>


          <Accordion
            expanded={expanded === "property"}
            onChange={handleExpand("property")}
            sx={{
              mb: 3,

              borderRadius: 1,
              width: "100%",
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            <AccordionSummary expandIcon={<MaterialIcons name="add" size={24} />}>
              <Typography fontWeight={600}>Property Details</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography mt={2}>
                <strong>Property Name:</strong>{" "}
                {openFlow?.property?.display_address || "N/A"}
              </Typography>

              <Typography>
                <strong>Bedrooms:</strong> {openFlow?.property?.bedrooms || "N/A"}
              </Typography>

              <Typography>
                <strong>Living Rooms:</strong>{" "}
                {openFlow?.property?.living_rooms || "N/A"}
              </Typography>

              <Typography>
                <strong>Furnished:</strong>{" "}
                {openFlow?.open_flow_rental_offer?.furnished || "N/A"}
              </Typography>
            </AccordionDetails>
          </Accordion>

          {/* ---------------- LANDLORDS ---------------- */}
          {Array.isArray(openFlow.open_flow_landlords) &&
            openFlow.open_flow_landlords.length > 0 && (
              <Accordion
                expanded={expanded === "landlords"}
                onChange={handleExpand("landlords")}
                sx={{
                  mb: 3,

                  borderRadius: 1,
                  width: "100%",
                  maxWidth: "100%",
                  overflow: "hidden",
                }}
              >
                <AccordionSummary expandIcon={<MaterialIcons name="add" size={24} />}>
                  <Typography fontWeight={600}>Landlord Details</Typography>
                </AccordionSummary>

                <AccordionDetails>
                  {openFlow.open_flow_landlords.map((landlord, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 3,
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                        backgroundColor: "#fafafa",
                      }}
                    >
                      <Typography variant="h6" fontWeight={600}>
                        Landlord {index + 1} {landlord.is_lead && "(Lead)"}
                      </Typography>

                      <Grid container spacing={2} mt={1}>
                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Title:</strong> {landlord.title || "N/A"}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Name:</strong> {landlord.first_name || "N/A"}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Surname:</strong> {landlord.last_name || "N/A"}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Email:</strong> {landlord.email || "N/A"}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Phone:</strong> {landlord.number || "N/A"}
                        </Grid>

                        <Grid item xs={12}>
                          <strong>Address:</strong>{" "}
                          {landlord.correspondece_address || "N/A"}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <strong>Post Code:</strong> {landlord.post_code || "N/A"}
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <strong>England Address:</strong>{" "}
                          {landlord.is_england_address ? "Yes" : "No"}
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
                </AccordionDetails>
              </Accordion>
            )}

          {/* ---------------- DEPOSIT ---------------- */}
          <Accordion
            expanded={expanded === "deposit"}
            onChange={handleExpand("deposit")}
            sx={{
              mb: 3,
              borderRadius: 1,
              width: "100%",
              maxWidth: "100%",
              overflow: "hidden",
            }}
          >
            <AccordionSummary expandIcon={<MaterialIcons name="add" size={24} />}>
              <Typography fontWeight={600}>Deposit Details</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography mt={2}>
                <strong>Rent Amount:</strong> £{payload.rental_amount || "N/A"}
              </Typography>

              <Typography>
                <strong>Rent Frequency:</strong> {payload.rental_frequency}
              </Typography>

              <Typography>
                <strong>Deposit Amount:</strong> £
                {payload.tenancy_deposit_amount || "N/A"}
              </Typography>

              <Typography>
                <strong>Amount to Protect:</strong> £
                {payload.tenancy_deposit_amount_protect || "N/A"}
              </Typography>

              <Typography>
                <strong>Holding Deposit Date:</strong>{" "}
                {formatDate(payload.holding_desposit_received_date)}
              </Typography>

              <Typography>
                <strong>Tenancy Start:</strong>{" "}
                {formatDate(payload.tenancy_start_date)}
              </Typography>

              <Typography>
                <strong>Tenancy End:</strong>{" "}
                {formatDate(payload.tenancy_end_date)}
              </Typography>

              <Typography>
                <strong>Number of Tenants:</strong>{" "}
                {payload.number_of_tenants || "N/A"}
              </Typography>

              <Typography>
                <strong>Organizational Tenant:</strong>{" "}
                {payload.is_organizational_tenant || "N/A"}
              </Typography>

              <Typography>
                <strong>Is Relative Person:</strong>{" "}
                {payload.is_relative_person || "N/A"}
              </Typography>

              <Typography>
                <strong>Agreement:</strong> {payload.agreement || "N/A"}
              </Typography>

              <Typography>
                <strong>Contact Address:</strong>{" "}
                {payload.contactAddress || "N/A"}
              </Typography>
            </AccordionDetails>
          </Accordion>

          {/* ---------------- TENANTS ---------------- */}
          {Array.isArray(openFlow.tenants) && openFlow.tenants.length > 0 && (
            <Accordion
              expanded={expanded === "tenants"}
              onChange={handleExpand("tenants")}
              sx={{
                mb: 3,

                borderRadius: 1,
                width: "100%",
                maxWidth: "100%",
                overflow: "hidden",
              }}
            >
              <AccordionSummary expandIcon={<MaterialIcons name="add" size={24} />}>
                <Typography fontWeight={600}>Tenants Details</Typography>
              </AccordionSummary>

              <AccordionDetails>
                {openFlow.tenants.map((tenant, index) => {
                  const user = tenant?.app_user?.user || {};

                  return (
                    <Box
                      key={index}
                      sx={{
                        mb: 3,
                        p: 2,
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                        backgroundColor: "#fafafa",
                      }}
                    >
                      <Typography variant="h6" fontWeight={600}>
                        Tenant {index + 1} {tenant.is_lead && "(Lead)"}
                      </Typography>

                      <Grid container spacing={2} mt={1}>
                        <Grid item xs={12} sm={6} md={4}>
                          <Typography>
                            <strong>Title:</strong> {user.title || "N/A"}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <Typography>

                            <strong>First Name:</strong> {user.first_name || "N/A"}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <Typography>

                            <strong>Last Name:</strong> {user.last_name || "N/A"}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <Typography>

                            <strong>Email:</strong> {user.email || "N/A"}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                          <Typography>

                            <strong>Phone:</strong> {user.contact_number || "N/A"}

                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  );
                })}
              </AccordionDetails>
            </Accordion>
          )}

          {/* ---------------- RELATIVE PERSON ---------------- */}
          {payload?.is_relative_person === "YES" && (
            <Accordion
              expanded={expanded === "relative"}
              onChange={handleExpand("relative")}
              sx={{
                mb: 3,
                borderRadius: 1,
                width: "100%",
                maxWidth: "100%",
                overflow: "hidden",
              }}
            >
              <AccordionSummary expandIcon={<MaterialIcons name="add" size={24} />}>
                <Typography fontWeight={600}>Relative Person Details</Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Typography mt={2}>
                  <strong>Title:</strong>{" "}
                  {payload?.relativePersonDetails?.title || "N/A"}
                </Typography>
                <Typography>
                  <strong>Name:</strong>{" "}
                  {payload?.relativePersonDetails?.name || "N/A"}
                </Typography>
                <Typography>
                  <strong>Surname:</strong>{" "}
                  {payload?.relativePersonDetails?.surname || "N/A"}
                </Typography>
                <Typography>
                  <strong>Email:</strong>{" "}
                  {payload?.relativePersonDetails?.email || "N/A"}
                </Typography>
                <Typography>
                  <strong>Phone:</strong>{" "}
                  {payload?.relativePersonDetails?.phone || "N/A"}
                </Typography>
                <Typography>
                  <strong>Address:</strong>{" "}
                  {payload?.relativePersonDetails?.address || "N/A"}
                </Typography>
              </AccordionDetails>
            </Accordion>
          )}

          {/* ---------------- BUTTONS ---------------- */}

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
            }}
          >

            <Box sx={{ display: "flex", gap: 2 }}>
              <Button variant="outlined" onClick={handleSaveDraft}>
                Save For Later
              </Button>

              <Button
                variant="contained"
                color="secondary"
                onClick={handleSubmitDeposit}
              >
                Register Deposit
              </Button>
            </Box>
          </Box>

        </Box>
      )
      }
    </>

  );
};

export default ConfirmationStep;
